import {
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  IconButton
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

function TableCustomizerDialog(props) {
  const { checked, indeterminate, onChange, style } =
    props.getToggleHideAllColumnsProps();
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <DialogTitle>
        Customize your columns.
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box sx={{ p: 2, width: 600 }}>
        <List
          sx={{
            p: 0,
            display: "flex",
            flexFlow: "column wrap",
            gap: "0 10px",
            height: 250,
            overflow: "auto",
          }}
        >
          <ListItem
            sx={{
              width: "auto",
              fontSize:"12px"
            }}
          >
            <Checkbox
              checked={checked}
              indeterminate={Boolean(indeterminate)}
              onChange={onChange}
              style={style}
              id="show-all-btn"
            />
            Show All
          </ListItem>
          {props.allColumns.map((column) => {
            if (column.id !== "selection") {
              return (
                <ListItem
                  key={column.Header}
                  sx={{
                    width: "auto",
                    fontSize:"12px"
                  }}
                >
                  <Checkbox {...column.getToggleHiddenProps()} />
                  {column.Header}
                </ListItem>
              );
            }
            return <></>;
          })}
        </List>
      </Box>
    </Dialog>
  );
}

export default TableCustomizerDialog;
